export enum PosStep {
  AddingProducts = 'adding-products',
  Paying = 'paying',
}
